import React, { useState } from 'react';
import { TextInput as RNTextInput, StyleSheet } from 'react-native';
import THEME from '../../config/theme';
import { useCustomTheme } from '../../contexts/useCustomTheme';
import { removeSansSerif } from '../../utils/validators';
import { hexToRgba } from '../../utils/colorUtils';

// Input das telas do ALUNO.
//
// Mesma geometria do AdminInput (altura 44, raio 10, borda de 1px, anel de foco)
// para que o app inteiro tenha um só padrão de campo — mas com a FONTE e as
// CORES DO CLIENTE, e não a paleta neutra do painel admin.
//
// Superfície, borda e placeholder são derivados da cor de texto da marca, então
// o campo tem contraste tanto em fundo claro quanto escuro. Campos somente
// leitura devem usar a mesma geometria com um fundo levemente mais forte.
//
// `scope`: 'app' (padrão, telas logadas) ou 'auth' (login/cadastro), seguindo a
// divisão que o customColor já faz entre os dois temas.
const BrandInput = ({
  scope = 'app',
  error,
  style,
  multiline,
  value,
  onFocus,
  onBlur,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const { customColor, customFont } = useCustomTheme();

  const textColor =
    (scope === 'auth' ? customColor?.text?.auth : customColor?.text?.app) ||
    THEME.COLORS.TEXT_MAIN;
  const accent = customColor?.primary || THEME.COLORS.PRIMARY_800;

  // Fundo transparente de propósito: derivar uma superfície da cor de texto
  // sempre escurece (tema claro) ou clareia (tema escuro) em relação ao card
  // onde o campo fica, e num dos dois casos ele sumiria. Contornado, o campo
  // funciona igual sobre qualquer fundo — e o campo somente leitura, esse sim
  // preenchido, continua se distinguindo como não editável.
  const surface = 'transparent';
  const border = hexToRgba(textColor, 0.22) || '#E5E7EB';
  const placeholder = hexToRgba(textColor, 0.45) || '#9CA3AF';
  const focusRing = hexToRgba(accent, 0.18) || 'rgba(43, 147, 237, 0.16)';

  return (
    <RNTextInput
      placeholderTextColor={placeholder}
      {...props}
      value={value == null ? '' : String(value)}
      multiline={multiline}
      onFocus={(e) => {
        setFocused(true);
        onFocus && onFocus(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur && onBlur(e);
      }}
      style={[
        styles.input,
        {
          backgroundColor: surface,
          borderColor: border,
          color: textColor,
          fontFamily: customFont?.fontFamilyText
            ? removeSansSerif(customFont.fontFamilyText)
            : THEME.FONTFAMILY.REGULAR,
        },
        multiline && styles.multiline,
        focused && { borderColor: accent, boxShadow: `0 0 0 3px ${focusRing}` },
        error && { borderColor: THEME.COLORS.ALERT },
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  input: {
    height: 44,
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 14,
    fontSize: 15,
    // web: tira o outline padrão do browser (o anel de foco é desenhado acima)
    outlineStyle: 'none',
  },
  multiline: {
    height: undefined,
    minHeight: 92,
    paddingTop: 12,
    textAlignVertical: 'top',
  },
});

export default BrandInput;
